import {Stack, Typography, styled} from '@mui/material';

const StyledMainStack = styled(Stack)`
	align-items: center;
	padding: ${({theme}) => theme.spacing(3)};
`;

const StyledTitle = styled(Typography)`
	text-align: center;
	margin-top: ${({theme}) => theme.spacing(2)};
`;

const StyledIconStack = styled(Stack)`
	flex-direction: row;
	gap: ${({theme}) => theme.spacing(4)};
	padding: ${({theme}) => theme.spacing(1, 0)};
	margin-top: ${({theme}) => theme.spacing(2)};
	align-items: center;
	border-bottom: 0.5px solid ${({theme}) => theme.palette.grey[300]};
`;

const StyledMiddleIconStack = styled(Stack)`
	flex-direction: row;
	gap: ${({theme}) => theme.spacing(4)};
	padding: ${({theme}) => theme.spacing(1, 0)};
	align-items: center;
	border-bottom: 0.5px solid ${({theme}) => theme.palette.grey[300]};
`;

const StyledLastIconStack = styled(Stack)`
	flex-direction: row;
	gap: ${({theme}) => theme.spacing(4)};
	padding: ${({theme}) => theme.spacing(1, 0)};
	margin-bottom: ${({theme}) => theme.spacing(3)};
	align-items: center;
	width: 100%;
`;

const LastDescription = styled(Typography)`
	width: 100%;
`;

const StyledFooterStack = styled(Stack)`
	flex-direction: column;
	gap: ${({theme}) => theme.spacing(1)};
	width: 100%;
`;

export const modalHeaderSx = {
	height: '64px',
	justifyContent: 'center',
};

export const dialogContentSx = {
	p: 'initial',
};

export {
	StyledMainStack,
	StyledTitle,
	StyledIconStack,
	StyledMiddleIconStack,
	StyledLastIconStack,
	LastDescription,
	StyledFooterStack,
};
